export const MODES = {
  SPRITE_TEXT: 'sprite-text',
  VIDEO_TEXT: 'video-text',
};

export const IMAGE_KINDS = {
  SPRITE: 'sprite',
  FREE: 'free',
};

export const VIDEO_KINDS = {
  SPRITE: 'sprite',
  FREE: 'free',
};

export const VIDEO_SOURCES = {
  SPRITE: 'sprite',
  GALLERY: 'gallery',
  UPLOAD: 'upload',
};

export const parseCreateVideoConfig = (search = window.location.search) => {
  const params = new URLSearchParams(search);
  const requestedMode = params.get('mode');
  const allowedModes = new Set(Object.values(MODES));
  const requestedKind = params.get('kind');
  const requestedSource = params.get('source');
  const mode = allowedModes.has(requestedMode) ? requestedMode : MODES.SPRITE_TEXT;
  const isVideo = mode === MODES.VIDEO_TEXT;
  return {
    mode,
    imageKind: !isVideo && requestedKind === IMAGE_KINDS.FREE ? IMAGE_KINDS.FREE : IMAGE_KINDS.SPRITE,
    videoKind: isVideo && requestedKind === VIDEO_KINDS.FREE ? VIDEO_KINDS.FREE : VIDEO_KINDS.SPRITE,
    videoSource: Object.values(VIDEO_SOURCES).includes(requestedSource)
      ? requestedSource
      : VIDEO_SOURCES.GALLERY,
    outputKey: params.get('output_key') || params.get('outputKey') || '',
    char: params.get('char') || '',
    outfit: params.get('outfit') ?? '',
    action: params.get('action') || '',
    intent: params.get('intent') || '',
  };
};
